/* eslint-disable react/jsx-no-target-blank */
import classNames from "classnames";
import React, { useEffect, useRef, useState } from "react";
import styles from "../../components/article/article.module.scss";
import StarRating from "../starRating/StarRating";
import { useRouter } from "next/router";

export default function VoteAndLike({ articleId, point, seoTitle }: { articleId?: number; point?: any; seoTitle?: string }) {
  const [rate, setRate] = useState<number>(point || 5);
  const [total, setTotal] = useState<number>(0);
  const [isRate, setIsRate] = useState<boolean>(false);
  const linkRef = useRef(null);
  
  const router = useRouter();

  const handleCopy = (e) => {
    e.preventDefault(); 
    if (linkRef.current) {
      const url = linkRef.current.href;
      navigator.clipboard.writeText(url).then(() => {
        alert("Copy url bài viết thành công!");
      }).catch(err => {
        console.error("Lỗi khi copy: ", err);
      });
    }
  };

  const handleRate = async (rate: number) => {
    point = point === "undefined" || !point ? 0 : point;
    fetch(`/blog/api/rate_article?articleId=${articleId}&rate=${rate}`)
      .then((response) => response?.json())
      .then((data) => {
        setRate(data.point);
        setTotal(data.total);
        setIsRate(true);
      });
  };

  useEffect(() => {
    async function checkRated() {
      fetch(`/blog/api/check_rated?articleId=${articleId}`)
        .then((response) => response?.json())
        .then((data) => {
          setTotal(data.total);
          setIsRate(data.exists === 0 ? false : true);
        });
    }
    checkRated();
    setRate(point);
  }, [articleId, point]);

  return (
    <div className={styles["box-vote-and-like"]}>
      <div className={styles["social-box"]}>
        <span>Chia sẻ bài viết:</span>
        <ul>
          <li>
            <a className={styles["share-fb"]} href={`https://www.facebook.com/sharer/sharer.php?u=${process.env.NEXT_PUBLIC_BASE_URL + process.env.NEXT_PUBLIC_BASE_PATH + router.asPath
              }`} title="Share lên Facebook" target="_blank" >
              <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.5" width="37" height="37" rx="5.5" stroke="currentColor" />
                <path d="M13 16.5556V21.4444H16.8182V30H21.9091V21.4444H25.7273L27 16.5556H21.9091V14.1111C21.9091 13.787 22.0432 13.4761 22.2819 13.2469C22.5205 13.0177 22.8443 12.8889 23.1818 12.8889H27V8H23.1818C21.4941 8 19.8755 8.64385 18.682 9.7899C17.4886 10.936 16.8182 12.4903 16.8182 14.1111V16.5556H13Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </a>
          </li>
          <li>
            <a className={styles["share-email"]} href={`https://mail.google.com/mail/?view=cm&fs=1&tf=1&body=${process.env.NEXT_PUBLIC_BASE_URL + process.env.NEXT_PUBLIC_BASE_PATH + router.asPath
              }`} target="_blank"  title="Share qua Email">
              <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.5" width="37" height="37" rx="5.5" stroke="currentColor" />
                <path d="M25.581 26.7094H12.2469C10.3588 26.7094 8.82794 25.1534 8.82794 23.2341V14.5459C8.82794 12.6266 10.3588 11.0706 12.2469 11.0706H25.581C27.4692 11.0706 29 12.6266 29 14.5459V23.2341C29 25.1534 27.4692 26.7094 25.581 26.7094Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12.247 14.5459L17.7054 20.268C18.373 20.9465 19.4555 20.9465 20.1231 20.268L25.5811 14.5459" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12.247 23.234L16.3498 18.8899" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M21.4782 18.8899L25.581 23.234" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </a>
          </li>
          <li>
            <a className={styles["share-x"]} href={`https://twitter.com/intent/tweet?text=${seoTitle} ${process.env.NEXT_PUBLIC_BASE_URL + process.env.NEXT_PUBLIC_BASE_PATH + router.asPath
                }`} target="_blank" title="Share lên X">
              <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.5" width="37" height="37" rx="5.5" stroke="currentColor" />
                <path d="M20.9053 17.4698L28.3516 9H26.5873L20.1184 16.3528L14.9561 9H9L16.8088 20.119L9 29H10.7643L17.5908 21.234L23.0439 29H29L20.9053 17.4698ZM18.4877 20.2171L17.6949 19.109L11.4009 10.3015H14.1113L19.193 17.4119L19.9819 18.52L26.5863 27.7623H23.876L18.4877 20.2171Z" fill="currentColor" />
              </svg>
            </a>
          </li>
          <li>
            <a className={styles["share-link"]} href="javascript:;" onClick={handleCopy} ref={linkRef} title="Copy url bài viết">
              <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.5" width="37" height="37" rx="5.5" stroke="currentColor" />
                <mask id="mask0_21_430" maskUnits="userSpaceOnUse" x="9" y="9" width="20" height="20">
                  <path d="M9.75 28.25V9.75H28.25V28.25H9.75Z" fill="white" stroke="white" strokeWidth="1.5" />
                </mask>
                <g mask="url(#mask0_21_430)">
                  <path d="M19.6286 16.7864C19.95 16.9695 20.2518 17.1995 20.526 17.4737C22.1739 19.1216 22.219 21.7487 20.1457 23.822L17.3376 26.6301C15.2643 28.7034 12.6372 28.6583 10.9893 27.0104C9.34136 25.3624 9.29625 22.7354 11.3696 20.662L13.4139 18.6092" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M18.3712 21.2136C18.0498 21.0305 17.7481 20.8006 17.4739 20.5263C15.8259 18.8784 15.7808 16.2514 17.8541 14.178L20.6622 11.3699C22.7356 9.29661 25.3626 9.34173 27.0105 10.9897C28.6585 12.6376 28.7036 15.2647 26.6303 17.338L24.5859 19.3908" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </g>
              </svg>
            </a>
          </li>
        </ul>
        
      </div>
      <div className={classNames(styles["kksr-align-right"], styles["kk-star-ratings"], "kksr-valign-bottom")}>
        <StarRating
          unit="float"
          handleOnClick={(e) => handleRate(e)}
          initialRating={total > 0 ? rate : 0}
          isReadOnly={isRate}
          activeColor={`${rate < 4 ? "#FCE340" : "#ffd055"}`}
          hoverColor={`${rate < 4 ? "#FCE340" : "#ffd055"}`}
          size={20}
        />
        <div className={styles["star-point"]}>
          <b>{rate}</b>/<b>5</b> &nbsp;(<b>{total}</b> vote)
        </div>
      </div>
    </div>
  );
}
